import * as Yup from "yup";
import moment from "moment";
import PostDocUploadFormModel from "./PostDocUploadFormModel";
const {
  formField: {
    // info
    statementReportGuideline,
    //info

    sendingFellowshipReport,
    mainResearchArea,
    researchTitleEnglish,
    progressCommencementFellowship,
    presentProgressResearchProject,

    //secAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
    whatYourStatus,
    AssessMainProgressAchieved,
    ListJournalSubject,
    researchPlanRelevantIndicates,
    additionalInformNote,
    additionalDocument,
    //secAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA

    //secBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
    submissionStatus,
    submitDate,
    receivedDate,
    revisedDate,
    articleTitle,
    manuscriptID,
    typeManuscript,
    journal,
    subjectAreaCategory,
    journalRanking,
    authors,
    firstAuthorName,
    correspondingAuthorName,
    coauthorAbroadPublication,
    coauthorName,
    coResearcherUniversityInstituteName,
    coResearcherUniversityInstituteRanking,
    supportedSecondCenturyFund,
    uploadManuscript,
    documentsShowingsSubmission,
    attachEvidenceTier1Paper,
    attachEvidenceUniversityInstituteRanking,
    additionalInformNoteSecB,
    additionalDocumentSecB,
    //secBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB

    //secCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC
    receivedDateSecC,
    submitDateSecC,
    acceptedDateSecC,
    revisedDateSecC,
    articleTitleSecC,
    manuscriptIDSecC,
    typeManuscriptSecC,
    journalSecC,
    subjectAreaCategorySecC,
    journalRankingSecC,
    authorsSecC,
    firstAuthorNameSecC,
    correspondingAuthorNameSecC,
    coauthorAbroadPublicationSecC,
    coauthorNameSecC,
    coResearcherUniversityInstituteNameSecC,
    coResearcherUniversityInstituteRankingSecC,
    supportedSecondCenturyFundSecC,
    uploadManuscriptSecC,
    documentsShowingsSubmissionSecC,
    publicationAcceptedEvidenceSecC,
    attachEvidenceTier1PaperSecC,
    attachEvidenceUniversityInstituteRankingSecC,
    additionalInformNoteSecC,
    additionalDocumentSecC,
    //secCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC
    
    //secDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD
    receivedDateSecD,
    submitDateSecD,
    acceptedDateSecD,
    revisedDateSecD,
    publishedDateSecD,
    articleTitleSecD,
    manuscriptIDSecD,
    typeManuscriptSecD,
    journalSecD,
    subjectAreaCategorySecD,
    journalRankingSecD,
    authorsSecD,
    firstAuthorNameSecD,
    correspondingAuthorNameSecD,
    coauthorAbroadPublicationSecD,
    coauthorNameSecD,
    coResearcherUniversityInstituteNameSecD,
    coResearcherUniversityInstituteRankingSecD,
    supportedSecondCenturyFundSecD,
    uploadManuscriptSecD,
    documentsShowingsSubmissionSecD,
    publicationAcceptedEvidenceSecD,
    attachEvidenceTier1PaperSecD,
    attachEvidenceUniversityInstituteRankingSecD,
    additionalInformNoteSecD,
    additionalDocumentSecD
    //secDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD
  }
} = PostDocUploadFormModel;

// const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;

// eslint-disable-next-line import/no-anonymous-default-export
export default function getSchemaForm(page, activeStep) {
  const FORM_SEC_A = "section_a";
  const FORM_SEC_B = "section_b";
  const FORM_SEC_C = "section_c";
  const FORM_SEC_D = "section_d";

  const schemaDefault = [
    Yup.object().shape({
      [statementReportGuideline.name]: Yup.string().required(
        `${statementReportGuideline.requiredErrorMsg}`
      )
    }),

    Yup.object().shape({
      [sendingFellowshipReport.name]: Yup.string().required(
        `${sendingFellowshipReport.requiredErrorMsg}`
      ),
      [mainResearchArea.name]: Yup.string()
        .trim()
        .required(`${mainResearchArea.requiredErrorMsg}`),
      [researchTitleEnglish.name]: Yup.string()
        .trim()
        .required(`${researchTitleEnglish.requiredErrorMsg}`),
      [progressCommencementFellowship.name]: Yup.string().required(
        `${progressCommencementFellowship.requiredErrorMsg}`
      ),
      [presentProgressResearchProject.name]: Yup.string().required(
        `${presentProgressResearchProject.requiredErrorMsg}`
      )
    })
  ];

  const schemaSecA = [
    Yup.object().shape({
      [statementReportGuideline.name]: Yup.string().required(
        `${statementReportGuideline.requiredErrorMsg}`
      )
    }),

    Yup.object().shape({
      [sendingFellowshipReport.name]: Yup.string().required(
        `${sendingFellowshipReport.requiredErrorMsg}`
      ),
      [mainResearchArea.name]: Yup.string()
        .trim()
        .required(`${mainResearchArea.requiredErrorMsg}`),
      [researchTitleEnglish.name]: Yup.string()
        .trim()
        .required(`${researchTitleEnglish.requiredErrorMsg}`),
      [progressCommencementFellowship.name]: Yup.string().required(
        `${progressCommencementFellowship.requiredErrorMsg}`
      ),
      [presentProgressResearchProject.name]: Yup.string().required(
        `${presentProgressResearchProject.requiredErrorMsg}`
      )
    }),

    Yup.object().shape({
      [whatYourStatus.name]: Yup.string()
        .trim()
        .required(`${whatYourStatus.requiredErrorMsg}`),
      [AssessMainProgressAchieved.name]: Yup.string().required(
        `${AssessMainProgressAchieved.requiredErrorMsg}`
      ),
      [ListJournalSubject.name]: Yup.string()
        .trim()
        .required(`${ListJournalSubject.requiredErrorMsg}`),

      [researchPlanRelevantIndicates.name]: Yup.object()
        .shape({
          [researchPlanRelevantIndicates.file]: Yup.object()
        })
        .nullable()
        .required(`${researchPlanRelevantIndicates.requiredErrorMsg}`),

      [additionalInformNote.name]: Yup.string()
        .trim()
        // .required(`${additionalInformNote.requiredErrorMsg}`)
        ,

      [additionalDocument.name]: Yup.object()
        .shape({
          [additionalDocument.file]: Yup.object()
        })
        .nullable()
        // .required(`${additionalDocument.requiredErrorMsg}`)
    })
  ];

  const schemaSecB = [
    Yup.object().shape({
      [statementReportGuideline.name]: Yup.string().required(
        `${statementReportGuideline.requiredErrorMsg}`
      )
    }),

    Yup.object().shape({
      [sendingFellowshipReport.name]: Yup.string().required(
        `${sendingFellowshipReport.requiredErrorMsg}`
      ),
      [mainResearchArea.name]: Yup.string()
        .trim()
        .required(`${mainResearchArea.requiredErrorMsg}`),
      [researchTitleEnglish.name]: Yup.string()
        .trim()
        .required(`${researchTitleEnglish.requiredErrorMsg}`),
      [progressCommencementFellowship.name]: Yup.string().required(
        `${progressCommencementFellowship.requiredErrorMsg}`
      ),
      [presentProgressResearchProject.name]: Yup.string().required(
        `${presentProgressResearchProject.requiredErrorMsg}`
      )
    }),

    Yup.object().shape({
      [submissionStatus.name]: Yup.string()
        .trim()
        .nullable()
        .required(`${submissionStatus.requiredErrorMsg}`),
      [submitDate.name]: Yup.string()
        .nullable()
        .required(`${submitDate.requiredErrorMsg}`),
      [receivedDate.name]: Yup.string()
        .nullable()
        .required(`${receivedDate.requiredErrorMsg}`),
      [revisedDate.name]: Yup.string()
        .nullable()
        .required(`${revisedDate.requiredErrorMsg}`),
      [articleTitle.name]: Yup.string()
        .trim()
        .required(`${articleTitle.requiredErrorMsg}`),
      [manuscriptID.name]: Yup.string()
        .trim()
        .required(`${manuscriptID.requiredErrorMsg}`),
      [typeManuscript.name]: Yup.string()
        .trim()
        .required(`${typeManuscript.requiredErrorMsg}`),
      [journal.name]: Yup.string()
        .trim()
        .required(`${journal.requiredErrorMsg}`),
      [subjectAreaCategory.name]: Yup.string()
        .trim()
        .required(`${subjectAreaCategory.requiredErrorMsg}`),
      [journalRanking.name]: Yup.string().required(
        `${journalRanking.requiredErrorMsg}`
      ),
      [authors.name]: Yup.string()
        .trim()
        .required(`${authors.requiredErrorMsg}`),
      [firstAuthorName.name]: Yup.string()
        .trim()
        .required(`${firstAuthorName.requiredErrorMsg}`),
      [correspondingAuthorName.name]: Yup.string()
        .trim()
        .required(`${correspondingAuthorName.requiredErrorMsg}`),
      [coauthorAbroadPublication.name]: Yup.string().required(
        `${coauthorAbroadPublication.requiredErrorMsg}`
      ),

      //////////////////////////////////////////////////////////////////////////////////////
      [coauthorName.name]: Yup.string().when(coauthorAbroadPublication.name, {
        is: (coAuthor) => coAuthor === 1,
        then: Yup.string().required(`${coauthorName.requiredErrorMsg}`)
      }),

      [coResearcherUniversityInstituteName.name]: Yup.string().when(
        coauthorAbroadPublication.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.string().required(
            `${coResearcherUniversityInstituteName.requiredErrorMsg}`
          )
        }
      ),

      [coResearcherUniversityInstituteRanking.name]: Yup.string().when(
        coauthorAbroadPublication.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.string().required(
            `${coResearcherUniversityInstituteRanking.requiredErrorMsg}`
          )
        }
      ),
      //////////////////////////////////////////////////////////////////////////////////////
      [supportedSecondCenturyFund.name]: Yup.string().required(
        `${supportedSecondCenturyFund.requiredErrorMsg}`
      ),
      [uploadManuscript.name]: Yup.object()
        .shape({
          [uploadManuscript.file]: Yup.object()
        })
        .nullable()
        .required(`${uploadManuscript.requiredErrorMsg}`),
      [documentsShowingsSubmission.name]: Yup.object()
        .shape({
          [documentsShowingsSubmission.file]: Yup.object()
        })
        .nullable()
        .required(`${documentsShowingsSubmission.requiredErrorMsg}`),
      [attachEvidenceTier1Paper.name]: Yup.object()
        .shape({
          [attachEvidenceTier1Paper.file]: Yup.object()
        })
        .nullable()
        .required(`${attachEvidenceTier1Paper.requiredErrorMsg}`),

      //////////////////////////////////////////////////////////////////////////////////////
      [attachEvidenceUniversityInstituteRanking.name]: Yup.mixed().when(
        coauthorAbroadPublication.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.object()
            .shape({
              [attachEvidenceUniversityInstituteRanking.file]: Yup.mixed()
            })
            .nullable()
            .required(
              `${attachEvidenceUniversityInstituteRanking.requiredErrorMsg}`
            )
        }
      ),
      //////////////////////////////////////////////////////////////////////////////////////

      [additionalInformNoteSecB.name]: Yup.string()
        .trim()
        // .required(`${additionalInformNoteSecB.requiredErrorMsg}`)
        ,
      [additionalDocumentSecB.name]: Yup.object()
        .shape({
          [additionalDocumentSecB.file]: Yup.mixed()
        })
        .nullable()
        // .required(`${additionalDocumentSecB.requiredErrorMsg}`)
    })
  ];

  const schemaSecC = [
    Yup.object().shape({
      [statementReportGuideline.name]: Yup.string().required(
        `${statementReportGuideline.requiredErrorMsg}`
      )
    }),

    Yup.object().shape({
      [sendingFellowshipReport.name]: Yup.string().required(
        `${sendingFellowshipReport.requiredErrorMsg}`
      ),
      [mainResearchArea.name]: Yup.string()
        .trim()
        .required(`${mainResearchArea.requiredErrorMsg}`),
      [researchTitleEnglish.name]: Yup.string()
        .trim()
        .required(`${researchTitleEnglish.requiredErrorMsg}`),
      [progressCommencementFellowship.name]: Yup.string().required(
        `${progressCommencementFellowship.requiredErrorMsg}`
      ),
      [presentProgressResearchProject.name]: Yup.string().required(
        `${presentProgressResearchProject.requiredErrorMsg}`
      )
    }),

    Yup.object().shape({
      [receivedDateSecC.name]: Yup.string()
        .nullable()
        .required(`${receivedDateSecC.requiredErrorMsg}`),
      [submitDateSecC.name]: Yup.string()
        .nullable()
        .required(`${submitDateSecC.requiredErrorMsg}`),
      [acceptedDateSecC.name]: Yup.string()
        .nullable()
        .required(`${acceptedDateSecC.requiredErrorMsg}`),
      [revisedDateSecC.name]: Yup.string()
        .nullable()
        .required(`${revisedDateSecC.requiredErrorMsg}`),
      [articleTitleSecC.name]: Yup.string()
        .trim()
        .required(`${articleTitleSecC.requiredErrorMsg}`),
      [manuscriptIDSecC.name]: Yup.string()
        .trim()
        .required(`${manuscriptIDSecC.requiredErrorMsg}`),
      [typeManuscriptSecC.name]: Yup.string()
        .trim()
        .required(`${typeManuscriptSecC.requiredErrorMsg}`),
      [journalSecC.name]: Yup.string()
        .trim()
        .required(`${journalSecC.requiredErrorMsg}`),
      [subjectAreaCategorySecC.name]: Yup.string()
        .trim()
        .required(`${subjectAreaCategorySecC.requiredErrorMsg}`),
      [journalRankingSecC.name]: Yup.string().required(
        `${journalRankingSecC.requiredErrorMsg}`
      ),
      [authorsSecC.name]: Yup.string()
        .trim()
        .required(`${authorsSecC.requiredErrorMsg}`),
      [firstAuthorNameSecC.name]: Yup.string()
        .trim()
        .required(`${firstAuthorNameSecC.requiredErrorMsg}`),
      [correspondingAuthorNameSecC.name]: Yup.string()
        .trim()
        .required(`${correspondingAuthorNameSecC.requiredErrorMsg}`),
      [coauthorAbroadPublicationSecC.name]: Yup.string().required(
        `${coauthorAbroadPublicationSecC.requiredErrorMsg}`
      ),
      //////////////////////////////////////////////////////////////////////////////////////
      [coauthorNameSecC.name]: Yup.string().when(
        coauthorAbroadPublicationSecC.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.string().required(`${coauthorNameSecC.requiredErrorMsg}`)
        }
      ),

      [coResearcherUniversityInstituteNameSecC.name]: Yup.string().when(
        coauthorAbroadPublicationSecC.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.string().required(
            `${coResearcherUniversityInstituteNameSecC.requiredErrorMsg}`
          )
        }
      ),

      [coResearcherUniversityInstituteRankingSecC.name]: Yup.string().when(
        coauthorAbroadPublicationSecC.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.string().required(
            `${coResearcherUniversityInstituteRankingSecC.requiredErrorMsg}`
          )
        }
      ),
      //////////////////////////////////////////////////////////////////////////////////////
      [supportedSecondCenturyFundSecC.name]: Yup.string().required(
        `${supportedSecondCenturyFundSecC.requiredErrorMsg}`
      ),
      [uploadManuscriptSecC.name]: Yup.object()
        .shape({
          [uploadManuscriptSecC.file]: Yup.object()
        })
        .nullable()
        .required(`${uploadManuscriptSecC.requiredErrorMsg}`),
      [documentsShowingsSubmissionSecC.name]: Yup.object()
        .shape({
          [documentsShowingsSubmissionSecC.file]: Yup.object()
        })
        .nullable()
        .required(`${documentsShowingsSubmissionSecC.requiredErrorMsg}`),
      [publicationAcceptedEvidenceSecC.name]: Yup.object()
        .shape({
          [publicationAcceptedEvidenceSecC.file]: Yup.object()
        })
        .nullable()
        .required(`${publicationAcceptedEvidenceSecC.requiredErrorMsg}`),
      [attachEvidenceTier1PaperSecC.name]: Yup.object()
        .shape({
          [attachEvidenceTier1PaperSecC.file]: Yup.object()
        })
        .nullable()
        .required(`${attachEvidenceTier1PaperSecC.requiredErrorMsg}`),
      //////////////////////////////////////////////////////////////////////////////////////
      [attachEvidenceUniversityInstituteRankingSecC.name]: Yup.mixed().when(
        coauthorAbroadPublicationSecC.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.object()
            .shape({
              [attachEvidenceUniversityInstituteRankingSecC.file]: Yup.mixed()
            })
            .nullable()
            .required(
              `${attachEvidenceUniversityInstituteRankingSecC.requiredErrorMsg}`
            )
        }
      ),
      //////////////////////////////////////////////////////////////////////////////////////
      [additionalInformNoteSecC.name]: Yup.string()
        .trim()
        // .required(`${additionalInformNoteSecC.requiredErrorMsg}`)
        ,
      [additionalDocumentSecC.name]: Yup.object()
        .shape({
          [additionalDocumentSecC.file]: Yup.object()
        })
        .nullable()
        // .required(`${additionalDocumentSecC.requiredErrorMsg}`)
    })
  ];

  const schemaSecD = [
    Yup.object().shape({
      [statementReportGuideline.name]: Yup.string().required(
        `${statementReportGuideline.requiredErrorMsg}`
      )
    }),

    Yup.object().shape({
      [sendingFellowshipReport.name]: Yup.string().required(
        `${sendingFellowshipReport.requiredErrorMsg}`
      ),
      [mainResearchArea.name]: Yup.string()
        .trim()
        .required(`${mainResearchArea.requiredErrorMsg}`),
      [researchTitleEnglish.name]: Yup.string()
        .trim()
        .required(`${researchTitleEnglish.requiredErrorMsg}`),
      [progressCommencementFellowship.name]: Yup.string().required(
        `${progressCommencementFellowship.requiredErrorMsg}`
      ),
      [presentProgressResearchProject.name]: Yup.string().required(
        `${presentProgressResearchProject.requiredErrorMsg}`
      )
    }),

    Yup.object().shape({
      [receivedDateSecD.name]: Yup.string()
        .nullable()
        .required(`${receivedDateSecD.requiredErrorMsg}`),
      [submitDateSecD.name]: Yup.string()
        .nullable()
        .required(`${submitDateSecD.requiredErrorMsg}`),
      [acceptedDateSecD.name]: Yup.string()
        .nullable()
        .required(`${acceptedDateSecD.requiredErrorMsg}`),
      [revisedDateSecD.name]: Yup.string()
        .nullable()
        .required(`${revisedDateSecD.requiredErrorMsg}`),
      [publishedDateSecD.name]: Yup.string()
        .nullable()
        .required(`${publishedDateSecD.requiredErrorMsg}`),
      [articleTitleSecD.name]: Yup.string()
        .trim()
        .required(`${articleTitleSecD.requiredErrorMsg}`),
      [manuscriptIDSecD.name]: Yup.string()
        .trim()
        .required(`${manuscriptIDSecD.requiredErrorMsg}`),
      [typeManuscriptSecD.name]: Yup.string()
        .trim()
        .required(`${typeManuscriptSecD.requiredErrorMsg}`),
      [journalSecD.name]: Yup.string()
        .trim()
        .required(`${journalSecD.requiredErrorMsg}`),
      [subjectAreaCategorySecD.name]: Yup.string()
        .trim()
        .required(`${subjectAreaCategorySecD.requiredErrorMsg}`),
      [journalRankingSecD.name]: Yup.string().required(
        `${journalRankingSecD.requiredErrorMsg}`
      ),
      [authorsSecD.name]: Yup.string()
        .trim()
        .required(`${authorsSecD.requiredErrorMsg}`),
      [firstAuthorNameSecD.name]: Yup.string()
        .trim()
        .required(`${firstAuthorNameSecD.requiredErrorMsg}`),
      [correspondingAuthorNameSecD.name]: Yup.string()
        .trim()
        .required(`${correspondingAuthorNameSecD.requiredErrorMsg}`),
      [coauthorAbroadPublicationSecD.name]: Yup.string().required(
        `${coauthorAbroadPublicationSecD.requiredErrorMsg}`
      ),
      //////////////////////////////////////////////////////////////////////////////////////
      [coauthorNameSecD.name]: Yup.string().when(
        coauthorAbroadPublicationSecD.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.string().required(`${coauthorNameSecD.requiredErrorMsg}`)
        }
      ),

      [coResearcherUniversityInstituteNameSecD.name]: Yup.string().when(
        coauthorAbroadPublicationSecD.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.string().required(
            `${coResearcherUniversityInstituteNameSecD.requiredErrorMsg}`
          )
        }
      ),

      [coResearcherUniversityInstituteRankingSecD.name]: Yup.string().when(
        coauthorAbroadPublicationSecD.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.string().required(
            `${coResearcherUniversityInstituteRankingSecD.requiredErrorMsg}`
          )
        }
      ),
      //////////////////////////////////////////////////////////////////////////////////////
      [supportedSecondCenturyFundSecD.name]: Yup.string().required(
        `${supportedSecondCenturyFundSecD.requiredErrorMsg}`
      ),
      [uploadManuscriptSecD.name]: Yup.object()
        .shape({
          [uploadManuscriptSecD.file]: Yup.object()
        })
        .nullable()
        .required(`${uploadManuscriptSecD.requiredErrorMsg}`),
      [documentsShowingsSubmissionSecD.name]: Yup.object()
        .shape({
          [documentsShowingsSubmissionSecD.file]: Yup.object()
        })
        .nullable()
        .required(`${documentsShowingsSubmissionSecD.requiredErrorMsg}`),
      [publicationAcceptedEvidenceSecD.name]: Yup.object()
        .shape({
          [publicationAcceptedEvidenceSecD.file]: Yup.object()
        })
        .nullable()
        .required(`${publicationAcceptedEvidenceSecD.requiredErrorMsg}`),
      [attachEvidenceTier1PaperSecD.name]: Yup.object()
        .shape({
          [attachEvidenceTier1PaperSecD.file]: Yup.object()
        })
        .nullable()
        .required(`${attachEvidenceTier1PaperSecD.requiredErrorMsg}`),
      //////////////////////////////////////////////////////////////////////////////////////
      [attachEvidenceUniversityInstituteRankingSecD.name]: Yup.mixed().when(
        coauthorAbroadPublicationSecD.name,
        {
          is: (coAuthor) => coAuthor === 1,
          then: Yup.object()
            .shape({
              [attachEvidenceUniversityInstituteRankingSecD.file]: Yup.mixed()
            })
            .nullable()
            .required(
              `${attachEvidenceUniversityInstituteRankingSecD.requiredErrorMsg}`
            )
        }
      ),
      //////////////////////////////////////////////////////////////////////////////////////

      [additionalInformNoteSecD.name]: Yup.string()
        .trim()
        // .required(`${additionalInformNoteSecD.requiredErrorMsg}`)
        ,
      [additionalDocumentSecD.name]: Yup.object()
        .shape({
          [additionalDocumentSecD.file]: Yup.object()
        })
        .nullable()
        // .required(`${additionalDocumentSecD.requiredErrorMsg}`)
    })
  ];

  switch (page) {
    case FORM_SEC_A:
      return schemaSecA[activeStep];
    case FORM_SEC_B:
      return schemaSecB[activeStep];
    case FORM_SEC_C:
      return schemaSecC[activeStep];
    case FORM_SEC_D:
      return schemaSecD[activeStep];
    default:
      return schemaDefault[activeStep];
  }
}
